import Grid from '@mui/material/Grid';
import { getLoginDataHelper } from '_controllers/helpers/getLoginData';
import { changeUser } from '_models/redux/change-user/action';
import { getCustomerProfile } from '_models/redux/customer-profile/action';
import { getTicketById } from '_models/redux/get-ticket-by-id/action';
import { getUsers } from '_models/redux/get-user-list/action';
import { getMyTickets } from '_models/redux/my-tickets/action';
import { rechargeHistoryAction } from '_models/redux/recharge-history/action';
import { rechargeHistoryClean } from '_models/redux/recharge-history/clean-action';
import ActionApplyPackage from 'modules/support/my-tickets/flow/detailTickets/components/actions-tickets/ActionApplyPackage.jsx';
import { connect } from 'react-redux';
import { ActionBarHook } from '../hooks/actionBarHook.js';
import AgentAssignment from './AgentAssignment.jsx';
import CustomDialogs from './CustomDialogs.jsx';
import MakePrepaid from './MakePrepaid.jsx';
import RechargeHistoryButton from './RechargeHistoryButton.jsx';
import SimActions from './SimActions.jsx';
import ActionBarring from './actions-tickets/ActionBarringComponent.jsx';
import ActionChangeZone from './actions-tickets/ActionChangeZone.jsx';
import ActionImei from './actions-tickets/ActionImeiComponent.jsx';
import LockImeiContainer from './actions-tickets/ActionLockImeiComponent.jsx';
import ActionPortability from './actions-tickets/ActionPortabilityComponent.jsx';
import ResumeLine from './actions-tickets/ActionResumeLineComponent.jsx';
import ActionSendApn from './actions-tickets/ActionSendApnComponent.jsx';
import SupplementaryService from './actions-tickets/ActionSupplementaryServiceComponent.jsx';
import ActionSuspendLine from './actions-tickets/ActionSuspendLineComponent.jsx';
import ActionUnbarring from './actions-tickets/ActionUnbarringComponent.jsx';
import UnlockImeiContainer from './actions-tickets/ActionUnlockImeiContainer.jsx';
const ActionsBar = (props) => {
  const { rechargeHistoryAction, rechargeHistory, rechargeHistoryClean } = props || {};
  const {
    handleChange,
    valueAgent,
    agentList,
    directNumber,
    imeiNumber,
    statusProfile,
    setisDialogOpenRechargeHistory,
    ticketId,
    setModalOpenSim,
    modalOpenSim,
    isDialogOpenRechargeHistory,
    dialogMessage,
    setIsDialogOpen,
    isDialogOpen,
  } = ActionBarHook(props);
  const { userPermissions } = getLoginDataHelper();
  const permissionsArray = userPermissions.split(',');
  const canSeeComponent = permissionsArray.includes('SUPPORT_TICKETS_SUPERVISOR');
  return (
    <Grid container>
      <Grid
        item
        size={{ xs: 12 }}
        className='button-box'
        textAlign={'start'}
        paddingLeft={2}
        paddingRight={2}
        direction='column'
      >
        <AgentAssignment
          handleChange={handleChange}
          valueAgent={valueAgent}
          agentList={agentList}
        />
        <RechargeHistoryButton onClick={() => setisDialogOpenRechargeHistory(true)} />{' '}
        {canSeeComponent && <MakePrepaid ticketId={ticketId} />}
        <ActionImei directNumber={directNumber} ticketId={ticketId} />
        <SimActions
          setModalOpenSim={setModalOpenSim}
          modalOpenSim={modalOpenSim}
          ticketId={ticketId}
        />
        <SupplementaryService directNumber={directNumber} ticketId={ticketId} />
        <ActionSendApn directNumber={directNumber} ticketId={ticketId} />
        <LockImeiContainer
          directNumber={directNumber}
          ticketId={ticketId}
          imeiNumber={imeiNumber}
        />
        <UnlockImeiContainer ticketId={ticketId} imeiNumber={imeiNumber} />
        {statusProfile === 'Active' && <ActionBarring ticketId={ticketId} />}
        {statusProfile === 'Barring (B1W) (Notified by client)' && (
          <ActionUnbarring ticketId={ticketId} />
        )}
        {statusProfile === 'Active' && (
          <ActionSuspendLine ticketId={ticketId} directNumber={directNumber} />
        )}
        {statusProfile === 'Suspend (B2W)' && (
          <ResumeLine ticketId={ticketId} directNumber={directNumber} />
        )}
        <ActionChangeZone ticketId={ticketId} directNumber={directNumber} />
        <ActionPortability ticketId={ticketId} directNumber={directNumber} />
        <ActionApplyPackage ticketId={ticketId} directNumber={directNumber} />
      </Grid>
      <CustomDialogs
        isDialogOpenRechargeHistory={isDialogOpenRechargeHistory}
        setisDialogOpenRechargeHistory={setisDialogOpenRechargeHistory}
        rechargeHistoryAction={rechargeHistoryAction}
        ticketId={ticketId}
        rechargeHistory={rechargeHistory}
        rechargeHistoryClean={rechargeHistoryClean}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        dialogMessage={dialogMessage}
      />
    </Grid>
  );
};
const mapStateToProps = (state) => ({
  tickets: state.tickets,
  events: state.events,
  customerProfile: state.customerProfile,
  userList: state.userList,
  changeUser_: state.changeUser_,
  ticketById: state.ticketById,
  rechargeHistory: state.rechargeHistory,
});
const mapDispatchToProps = {
  getMyTickets,
  getCustomerProfile,
  getUsers,
  changeUser,
  getTicketById,
  rechargeHistoryAction,
  rechargeHistoryClean,
};
export default connect(mapStateToProps, mapDispatchToProps)(ActionsBar);
